module.exports = __webpack_public_path__ + "img/img63.8dd06956.png";